import { render, staticRenderFns } from "./orders-weekly.vue?vue&type=template&id=29666126&scoped=true&lang=pug&"
import script from "./orders-weekly.vue?vue&type=script&lang=js&"
export * from "./orders-weekly.vue?vue&type=script&lang=js&"
import style0 from "./orders-weekly.vue?vue&type=style&index=0&id=29666126&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29666126",
  null
  
)

export default component.exports